import { Entry } from "../../../shared/types";
import { sanitizeImgUrls } from "../helpers/functions";
import { get, GetAllResponse, GetResponse, post, put, remove } from "./_base";

const path = "entries";

const sanitizeEntry = (response: GetResponse<Entry>): GetResponse<Entry> => {
  return {
    ...response,
    data: response?.data ? sanitizeEntryData(response.data) : ({} as any),
  };
};

const sanitizeEntryData = (entry: Entry): Entry => {
  if (!entry) return entry;
  return {
    ...entry,
    image: {
      ...entry.image,
      path: sanitizeImgUrls(entry.image?.path),
    },
    text: sanitizeImgUrls(entry.text),
  };
};

const sanitizeEntries = (
  response: GetAllResponse<Entry>
): GetAllResponse<Entry> => {
  return {
    ...response,
    data: Array.isArray(response?.data)
      ? response.data.map(sanitizeEntryData)
      : [],
  };
};

export class EntriesActions {
  static post = async (data: Entry) => {
    return await post(path, data);
  };
  static get = async (data: Partial<Entry>) => {
    const response = (await get(path, data, {
      single: true,
    })) as GetResponse<Entry>;

    return sanitizeEntry(response);
  };
  static getAll = async (data: Partial<Entry>) => {
    const response = (await get(path, data)) as GetAllResponse<Entry>;

    return sanitizeEntries(response);
  };
  static put = async (data: Entry) => {
    return await put(path, data);
  };
  static remove = async (id: string) => {
    return await remove(path, id);
  };
}
